import { Button } from 'components/base';
import LevelUpImg from 'assets/images/level-up.png';
import useTranslation from 'hooks/useTranslation';
import { useNavigate } from 'react-router-dom';

const LevelUp = () => {
  const translation = useTranslation();
  const navigate = useNavigate();

  const toOrder = () => {
    navigate('/order');
  };

  const WhatsAppLink = () => {
    const phoneNumber = '+41796970821';
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl);
  };


  return (
    <div className="flex flex-col bg-level-up-mobile bg-contain bg-[center_bottom_60px] bg-no-repeat px-4 py-20 lg:items-center lg:bg-level-up-desktop lg:bg-[center_bottom_0px] lg:px-[341px] lg:pb-0 lg:pt-[120px]">
      <p className="text-xs font-bold uppercase tracking-wide text-primary-light-blue">
        {translation.readyToLevelUp}
      </p>
      <p className="mt-3 text-2xl font-bold text-primary-blue lg:mt-4 lg:text-4xl">
        {translation.startGrowing}
      </p>

      <div className="lg:mt-[54px] lg:flex">
        {/*<Button
          onClick={toOrder}
          theme="PRIMARY"
          className="mt-8 w-full lg:mx-2 lg:mt-0 lg:w-[218px]"
        >
          <p>{translation.getStarted}</p>
        </Button>*/}

        <Button
          onClick={WhatsAppLink}
          theme="OUTLINE"
          className="mt-3 w-full border-primary-light-blue lg:mx-2 lg:mt-0 lg:w-[218px] lg:px-8"
        >
          <p className="font-semibold text-primary-light-blue">
            {translation.getFreeConsult}
          </p>
        </Button>
      </div>

      <img
        alt=""
        src={LevelUpImg}
        className="mt-20 h-[192px] w-full lg:mt-[100px] lg:h-[423px] lg:w-[757px]"
      />
    </div>
  );
};

export default LevelUp;
